import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { UploadFile } from "../../../core/models/upload-file-fields";

@Component({
  selector: "app-file-upload",
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: "./file-upload.component.html",
  styleUrl: "./file-upload.component.scss",
})
export class FileUploadComponent {
  @Input() data: UploadFile = {};
  @Input() viewOnly = false;
  @Input() value: string = '';
  @Output() filesSelected = new EventEmitter<{ files: File[] }>();

  selectedFiles: any = [];
  files: string = "";

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFiles= Array.from(input.files);
      this.filesSelected.emit({
        files: this.selectedFiles,
      }); // Emit selected files
    }

    this.files = this.selectedFiles.map((file: any) => file.name).join(", ");
  }

  isObjectEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length === 0;
  }
}
